import { useState } from "react";
import { Badge, IconButton, SxProps, Theme, Tooltip } from "@mui/material";
import { Bell } from "lucide-react";

import { useNotificationsPoller } from "@hooks/useNotificationsPoller";
import { useMarkSeenMutation } from "@services/api/notifications";

import { NotificationsPanel } from "./NotificationsPanel";

export interface NotificationsBellProps {
    /** Permite que cada layout (v1, v2) le dé el estilo de su propia barra de íconos. */
    sx?: SxProps<Theme>;
    iconSize?: number;
}

export const NotificationsBell = ({ sx, iconSize = 24 }: NotificationsBellProps) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const { data } = useNotificationsPoller();
    const [markSeen] = useMarkSeenMutation();

    const unseen = data?.unseen_count ?? 0;

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        if (unseen > 0) markSeen();
    };

    return (
        <>
            <Tooltip title="Notificaciones">
                <IconButton
                    onClick={handleOpen}
                    sx={sx}
                    aria-label={unseen > 0 ? `Notificaciones, ${unseen} sin ver` : "Notificaciones"}
                    aria-haspopup="dialog"
                >
                    <Badge badgeContent={unseen} max={99} color="error">
                        <Bell size={iconSize} />
                    </Badge>
                </IconButton>
            </Tooltip>

            <NotificationsPanel anchorEl={anchorEl} onClose={() => setAnchorEl(null)} />
        </>
    );
};
